import { render, staticRenderFns } from "./RevisarReservaNavidad.vue?vue&type=template&id=1e3b71b2&scoped=true&"
import script from "./RevisarReservaNavidad.vue?vue&type=script&lang=ts&"
export * from "./RevisarReservaNavidad.vue?vue&type=script&lang=ts&"
import style0 from "./RevisarReservaNavidad.vue?vue&type=style&index=0&id=1e3b71b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3b71b2",
  null
  
)

export default component.exports